"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _MarginTrading = _interopRequireDefault(require("./MarginTrading"));
var _FuturesTrading = _interopRequireDefault(require("./FuturesTrading"));
require("./TradeSettings.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var themeClasses = (0, _cssClassesHelper.getBEMClasses)('trade-settings');
var TradeSettings = function TradeSettings() {
  var _useTranslation = (0, _reactI18next.useTranslation)('user'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('header')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('header-text')
  }, t('Adjust Trade Settings')), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('description')
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('settings-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('settings')
  }, /*#__PURE__*/_react["default"].createElement(_MarginTrading["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('settings')
  }, /*#__PURE__*/_react["default"].createElement(_FuturesTrading["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('row')
  })));
};
var _default = exports["default"] = TradeSettings;